import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import styles from '@/components/SectionErrorBoundary.module.css';
import { Button, ButtonLink } from '@/components/ui/Button';
import { useT } from '@/i18n/LocaleProvider';

/** Ошибка загрузки маршрута или lazy-чанка. */
export function RouteErrorFallback() {
  const error = useRouteError();
  const t = useT();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : t('errors.unknown');

  return (
    <div className={styles.fallback} role="alert">
      <p className={styles.eyebrow}>{t('errors.sectionTitle')}</p>
      <h2 className={styles.title}>{t('errors.pageFailed')}</h2>
      <p className={styles.text}>{message}</p>
      <div className={styles.actions}>
        <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
          {t('errors.reload')}
        </Button>
        <ButtonLink variant="ghost" size="sm" href={import.meta.env.BASE_URL}>
          {t('errors.backToCatalog')}
        </ButtonLink>
      </div>
      <Link to="/" hidden>
        {t('nav.catalog')}
      </Link>
    </div>
  );
}
